import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <h1>Namaste</h1> <br />
          <p style={{ textAlign: "justify" }}>
            I am <span className="purple">Ashwin Jagarwal </span>
            from <span className="purple"> Rajasthan, India.</span>
            <br />I am currently in my final year as an undergraduate student at
            the{" "}
            <span className="purple">
              National Institute of Technology, Kurukshetra.
            </span>
            <br />
            <br />
            <span className="purple">Coding</span> enthusiast with a passion for
            exploring <span className="purple">blockchain </span> and
            <span className="purple"> traveling the world. </span>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
